import { useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { useOrg } from "@/hooks/useOrg";
import { toast } from "sonner";

export default function Onboarding() {
  const { user, loading: authLoading } = useAuth();
  const { orgs, loading: orgLoading, refetch, switchOrg } = useOrg();
  const navigate = useNavigate();
  const creating = useRef(false);

  useEffect(() => {
    if (authLoading || orgLoading || !user || creating.current) return;

    if (orgs.length > 0) {
      navigate("/dashboard", { replace: true });
      return;
    }

    creating.current = true;

    (async () => {
      const { data: orgId, error } = await (supabase as any).rpc("ensure_my_default_org");

      if (error) {
        toast.error(error.message);
        creating.current = false;
        return;
      }

      await refetch();
      if (orgId) switchOrg(orgId);
      navigate("/dashboard", { replace: true });
    })();
  }, [authLoading, orgLoading, user, orgs.length, refetch, switchOrg, navigate]);

  if (authLoading || orgLoading) return null;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <p className="text-sm text-muted-foreground">Setting up your workspace…</p>
    </div>
  );
}
